import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { formApiUrl } from '../../../../../utils';
// constant
import { FORM_REFS } from '../../../../../constants';
// restClient
import { aemHostClient, eapiClient } from '../../../../../restClient';
// children
import Dynamicform from '../../../../common/Dynamicform/dynamicForm';
//action Creator
import { updatedAccountInfo, setStandAloneAccounts } from '../actions/actionCreator';
//style
import { Translations } from '../../../../../utils';
import { blockUi, unBlockUi } from '../../../../../actions/actionCreator';


//import './AddOtherAccount.css';

class CreateNewNotionalPoolingOtherAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  componentWillMount() {
    // let apiURL = "/aemData/formData/json_add-gls-bank-subform-notional-page";
    let apiURL = "/aemData/formData/json_gls-add-other-account-hsbc-np";
    if (this.props.mode === "edit") {
      apiURL = apiURL.replace("json_gls-add-", "json_gls-edit-");
    }
    aemHostClient(apiURL)
      .then(({ data }) => {
        this.setState({ formJson: data });
      });
  }

  getFormData = (formData) => {
    this.setState({ formData });
    this.props.updatedAccountInfo(formData, formData.id)
  }

  onFormSubmit = (event, apiURL) => {
    this.props.blockUi();
    let { otherAccountId, productId } = this.props.match.params;
    var requestData = {
      ...this.state.formData,
      bankName: 'HSBC',
      hsbcAccount: 'hsbc'
    };

    if (this.props.mode === 'edit') {
      apiURL = this.translations(apiURL) + "/" + this.state.formData.id;
    } else {
      apiURL = this.translations(apiURL)
    }

    var METHOD = this.props.mode === 'edit' ? 'PUT' : 'POST';
    eapiClient(formApiUrl(apiURL, ":glsId", productId), {
      method: METHOD,
      data: JSON.stringify(requestData)
    })
      .then(({ data }) => {
        this.props.setStandAloneAccounts(data.responseData.otherAccounts);
        var key = window.sessionStorage.getItem("getCurrentDropDown");
        const savedPageStateString = window.sessionStorage.getItem("previousPageState");
        const savedPageState = savedPageStateString ? JSON.parse(savedPageStateString) : undefined;
        if (otherAccountId !== undefined) {
          let accountId = savedPageState.selectedAccounts[0];
          let selectAccountId = data.responseData.otherAccounts.filter(cur => {
            return cur.id === otherAccountId
          })
          window.sessionStorage.setItem('key' + key, JSON.stringify({ ...selectAccountId[0] }));
        } else {
          window.sessionStorage.setItem('key' + key, JSON.stringify({ ...data.responseData.otherAccounts[data.responseData.otherAccounts.length - 1] }));
        }

        this.props.history.goBack();
        this.props.unBlockUi();
      });
  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  renderFormGroups() {
    let formData;
    const savedPageStateString = window.sessionStorage.getItem("previousPageState");
    const savedPageState = savedPageStateString ? JSON.parse(savedPageStateString) : ''

    if (this.props.currentOtherAccount !== undefined) {
      formData = { ...this.props.currentOtherAccount };
    } else {
      formData = {};
    }
    const properties = {
      accountId: this.props.match.params.accountId,
      formData,
      editType: 'create-new-notionalPool-other-account',
      pathname: this.props.history.location.pathname,
      setCurrency: savedPageState.poolCurrency,
      setCountry: savedPageState.setLocation !== undefined ? savedPageState.setLocation : (this.props.PoolLocaion && this.props.PoolLocaion.value)
    };

    if (this.state.formJson !== undefined && this.state.formJson.par.aemform_ !== undefined) {
      return (
        <Dynamicform
          mode={this.props.mode}
          properties={properties}
          url={FORM_REFS[this.state.formJson.par.aemform_.formRef]}
          getFormData={this.getFormData}
          forceValidations={this.props.mode === 'edit' ? false : true}
          history={this.props.history}
          match={this.props.match}
          onFormSubmit={this.onFormSubmit}
          onFormCancel={this.onFormCancel}
          lang={this.props.lang.currentLang.lang}
          translatedData={this.props.lang.translatedData}
        />
      );
    }
  }

  render() {
    const pageTitle = this.state.formJson ? this.state.formJson['par'].page_title_mainTitle : '';
    return (
      <div className="form-container">
        <div className="form-title">
          <h2 className="form-heading">{this.translations(pageTitle.pageHeading)}</h2>
          <p className="form-required-desc">{this.translations(pageTitle.descriptionText)}</p>
        </div>
        {
          this.renderFormGroups()
        }
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  let currentOtherAccount = undefined;
  if (props.match.params) {
    var { otherAccountId } = props.match.params;
    if (otherAccountId && state.currentProductNotionalPooling.accounts.length > 0) {
      state.currentProductNotionalPooling.accounts.forEach(otherAccount => {
        if (otherAccount.id === otherAccountId) {
          currentOtherAccount = otherAccount
        }
      });
    }
  }
  return {
    currentOtherAccount,
    mode: currentOtherAccount !== undefined ? 'edit' : '',
    lang: state.lang,
    PoolLocaion: state.currentProductNotionalPooling.data.location
  };
}

const mapDispatchToProps = dispatch => {
  return {
    updatedAccountInfo: (data, id) => {
      dispatch(updatedAccountInfo(data, id))
    },
    setStandAloneAccounts: accounts => {
      dispatch(setStandAloneAccounts(accounts))
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewNotionalPoolingOtherAccount);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsNotionalPooling/GlsNotionalPoolingStrucutre/CreateNewNotionalPoolingOtherAccount.js